import * as React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

type UsageRowProps = React.PropsWithChildren<{
  title: string;
  description: string;
  className?: string;
  hasBorderBottom?: boolean;
}>;

const UsageRow = ({
  title,
  description,
  children,
  className,
  hasBorderBottom = true,
}: UsageRowProps) => {
  return (
    <div
      className={twMerge(
        "flex items-start justify-between gap-6 p-5",
        hasBorderBottom && "border-b-0.5 border-border",
        className,
      )}
    >
      <div className="flex flex-col gap-1 flex-1">
        <span className="text-sm font-medium">{title}</span>
        <span className="text-sm text-muted">{description}</span>
      </div>
      <div className="flex-shrink-0">{children}</div>
    </div>
  );
};

export default UsageRow;
